import { render, staticRenderFns } from "./RecruiterAsign.vue?vue&type=template&id=643246e4&"
import script from "./RecruiterAsign.vue?vue&type=script&lang=js&"
export * from "./RecruiterAsign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports